import { config } from 'process'

export default {
  button: {
    edit: '編輯',
    modify: '修改',
    return: '返回',
    add: '添加',
    addBan: '添加封禁账户',
    del: '刪除',
    authorization: '授權',
    secret: '修改 Google 密钥',
    resetSecret: '重置 Google 密鑰',
    delMessage: '確定刪除嗎？',
    modifyMessage: '確定修改嗎？',
    cancel: '不了',
    confirm: '是的',
    save: '保存',
    ordinary: '普通版',
    speed: '極速版',
    batchNotify: '批量通知',
    empty: '清空',
    close: '關閉',
    jump: '確認跳轉',
    query: '查詢',
    jumpMerchant: '跳轉',
    config: '配置',
    breaker: '關閉警告',
    refresh: '清除緩存',
    share: '分享',
    version: '歷史版本',
    sendMes: '發送消息',
    batchCollect: '批量歸集',
    productConfig: '收銀臺配置',
    sendGroupMes: '设置发送的群消息',
    submit: '提交',
    setTimeZone: '设置货币时区',
    UnderstandProduct: '瞭解産品',
    delImg: '刪除圖片',
    preview: '預覽圖片',
    clearCount: '清除計數',
    info: '信息',
    reset: '重置機器人',
    bind: '綁定機器人',
    copy: '復製',
    upload: '上傳',
    refund: '一鍵退款',
    export: '交易導出',
    notification: '一鍵通知',
    configuration: '修改配置',
    detele: '刪除自定義',
    rate: '結算金額百分比',
    type: '結算類型',
    cycle: '結算周期',
    time: '時間單位',
    batchReview: '批量审核',
    start: '開啟',
    none: '不設置',
    sig: '申请多签',
    callback: '回调',
    Deprecated: '作废',
    batchDisable: '批量停用',
    batchRestart: '批量重启',
    invert: '过滤商户号',
    newRate: '手續費',
    subFee: '查看手續費詳情',
    refund1: '退款',
    rolling: '循环保证金',
  },
  batch: {
    limitRange: '限制范围',
    min_amount: '最小金额',
    max_amount: '最大金额',
    batchEdit: '批量编辑',
    limited: '每⽇限定交易筆數',
    del: '批量刪除',
    delAccounts: '賬戶名稱',
    description: '描述',
    googleCode: '谷歌驗證碼',
    allNotice: '通知當前產品內的所有賬戶，請謹慎操作',
    refund: '批量退款',
    errList: '退款失败订单列表',
    msg: '错误说明',
    enable: '批量启用',
    errText: '最多200个订单批量代付操作',
    checkUpload: '编辑可用时间请勾选'

  },
  endMessage: {
    send: '发送消息',
    group: 'Telegram 群组',
    tGroup: '群组',
    text: '文本',
    photo: '图片',
    video: '視頻',
    upload: '上传图片',
    select: '消息類型',
    textArea: '消息內容',
    all: '全选',
    groupSearch: '输入群分类查询群组',
    boundGroup: '已綁定群',
    management: '管理',
    groupList: '群列表',
    groupName: '群名稱',
    groupId: '群 ID',
    forward_chat_id: '转发群 ID',
    forward_extra_text: '转发备注',
    permission: '群消息權限',
    deactivate: '停用',
    information: '編輯群信息',
    bot_type: '查单类型',
    deleteVideo: '刪除視頻',
    classification: '群分類',
    classify: '分類',
    name: '分類名稱',
    description: '分類描述',
    Send: '發送',
    addType: '新增群分類',
    editType: '編輯群分類',
    comds: '指令',
    order_list: '指令列表',
    default: '默認',
    defined: '自定義',
    confirm: '確認編輯'
  },
  time: {
    halfhHour: '最近半小時',
    oneHour: '最近一小時',
    fourHour: '最近四小時',
    yesterday: '昨天',
    lastMonth: '上月',
    aWeek: '最近一周',
    aMonth: '最近一個月',
    threeMonths: '最近三個月',
    five: '五分鐘',
    ten: '十分鐘'
  },
  jump: {
    jump: '是否需要跳轉到 H5 後臺頁面'
  },
  page: {
    prev: '上頁',
    next: '下頁'
  },
  upload: {
    tips: '可將文件拖到此處'
  },
  tag: {
    approve: '批准',
    reject: '拒绝',
    wait: '待审核'
  },
  table: {
    username: '用户名',
    password: '密码',
    email: '电子邮件',
    ip_whiteList: 'IP白名单 ',
    task_description: '任务描述',
    manager_type: '管理人员类型',
    total: '总计',
    successful_volume: '成功的金额',
    successful_ransaction: '交易成功',
    success_amount: '成功金额',
    pending_amount: '在途金额',
    pending_transaction: '在途笔数',
    approval_amount: '审批金额',
    approval_transaction: '审批交易 ',
    reject_amount: '拒绝金额',
    reject_transaction: '拒绝交易',
    transaction: '交易笔数',
    volume: '金额',
    dealVolume: '交易量',
    successful_rate: '成功率',
    today: '今天',
    notify_status: '通知商户状态',
    product_name: '產品名称 ',
    product_code: '產品',
    product_account: '產品賬戶',
    upstream_ordernumber: '賬戶订单号',
    min_amount: '最低金额',
    max_amount: '最大金额',
    notify_time: '通知时间',
    notify_start_time: '通知开始时间',
    notify_end_time: '通知结束时间 ',
    source: '订单发源地 ',
    backoffice_payout: '后台支付',
    id: 'ID',
    currency: '货币',
    merchant_ref: '商户订单号',
    systemRef: '平台订单号',
    system_ref: '平台订单号',
    requset_amount: '请求金额',
    paid_amount: '实际支付金额',
    product: '产品',
    order_status: '订单状态 ',
    title: '标题 ',
    description: '描述',
    bank: '银行 ',
    remarks: '备注',
    reason: '原因',
    order_number: '订单号',
    account_name: '收款人',
    account_no: '收款卡号',
    status: '状态',
    platformStatus: '平台订单状态',
    taskStatus: '任务状态',
    created_start_time: '创建开始时间',
    created_end_time: '创建结束时间',
    insruction: '操作说明',
    bank_name: '银行名称',
    bank_code: '银行代码',
    amount: '支付金额',
    fee: '手续费',
    approved_by: '审批人',
    approved_time: '批准时间',
    created_by: '创建人',
    created_time: '创建时间',
    operation: '操作',
    bank_account: '银行账户',
    extend_params: '扩展参数',
    information: '信息',
    cause: '原因',
    before_balance: '之前的余额',
    after_balance: '之后的余额',
    sourceIP: '源 IP',
    date: '日期',
    merchant_no: '商户号',
    merchant_name: '商户名称',
    begin_balance: '日初余额',
    end_balance: '日终余额',
    startingBalance: '日初在途余额',
    endingBalance: '日终在途余额',
    type: '类型',
    dealType: '交易类型',
    change_amount: '管理员补单金额',
    change_transaction: '管理员补单笔数',
    product_type: '产品类型',
    settlementLimit: '结算类型',
    transitionLimit: '金额限制',
    transitionTime: '可用时间',
    notify: '通知',
    details: '详细说明',
    agentFee: '代理费用',
    agentNo: '上级商户号',
    commission: '佣金',
    success_transaction: '成功交易',
    review: '审查',
    address: '地址',
    coin_type: '硬币类型',
    expectStatus: '预期状态',
    attach: '附加',
    success_time: '成功时间',
    success_start_time: '成功开始时间',
    success_end_time: ' 成功结束时间',
    succeedRequestAmount: '成功请求数量',
    succeedVolume: '成功订单',
    succeedPaidAmount: '成功支付金额',
    conversionRate: '转化率',
    mode: '处理方式',
    placeholder: '填寫原因，並審核',
    smsLink: '下載短信轉發器',
    plugin_name: '插件名',
    lastest_version: '插件版本',
    download_link: '下載鏈接',
    version: '版本號',
    renew: '版本更新內容',
    reuse_address: '復用存款地址',
    reuse_address_days: '间隔天数',
    not_reuse_address: '不重复使用地址商户号',
    reuse_address_count: '可用地址數量',
    collect_by_stake: '質押歸集',
    pledgeType: '質押類型',
    pledgeAccount: '質押賬戶',
    pledgeAddress: '質押地址',
    path: '路徑',
    name: '收銀臺名稱',
    between: '間隔天數',
    sort: '序號',
    sort_L: '序號',
    noData: '暫無資料',
    reuse_upstream_accounts: '重復使用上遊帳戶頻率',
    walletName: '錢包名稱',
    rakeBack: '下級代理當日返傭',
    login_ip: '登录IP',
    recharge_address: '充值地址'
  },
  tips: {
    tips: '提示：',
    batchPaid: '只有待處理的訂單才可以支付',
    batchChange: '只有待處理的訂單可以更改',
    batchUnfreeze: '只有凍結訂單才能解凍',
    batchNotify: '只有未通知的訂單才能被通知',
    currentSystem: '當前系統中待處理的訂單總數',
    kick: '只有在隊列中的訂單才能踢出隊列',
    path: '當前產品無法配置收銀臺路由',
    ipRemind: '每個輸入框只能輸入一個IP，多個IP無效!',
    apikeyshow: 'API 密钥已修改，请妥善保管，请勿向他人泄漏。',
    search: '通过手机号、用户名查找账户'
  },
  checkbox: {
    checkAll: '全选'
  },
  route: {
    adminMgt: '管理員管理',
    adminList: '列表',
    taskCenter: '任務中心',
    applicationTask: '管理員特殊事項申請',
    banAccount: '封禁账户',
    product: '產品',
    productManage: '產品管理',
    accountManage: '賬戶管理',
    walletAddress: '錢包地址',
    merchantMgt: '商戶管理',
    merchantList: '商戶列表',
    accountGroup: '帳戶組',
    antAccountGroup: '螞蟻賬戶組',
    smsLog: '短信日誌',
    order: '訂單管理',

    dashboard: '首頁',
    backToTop: '返回頂部',
    errorPages: '錯誤頁面',
    page401: '401',
    page404: '404',
    errorLog: '錯誤日誌',
    theme: '换肤',
    profile: '個人中心',

    log: '日誌',
    loginLog: '登錄日誌',
    accessDevice: '访问设备管理',

    test: '測試中心',
    setting: '系統設置',
    download: '下載中心',
    appSoftware: '通道市場',

    withdrawReview: '出金審查',
    antOrderReview: '螞蟻搶單審核',
    depositReview: '入金審查',
    exceptionTask: '異常訂單',
    bankBill: '銀行賬單',
    upstreamBill: '上遊賬單',
    rechargeCurrency: '法幣充值',
    subAccount: '子賬戶',
    smsAccount: '短信賬戶',
    cardAccount: '卡商賬戶',
    antReview: 'USDT-TRCPayout審批',
    smsManage: '商户短信',
    antRegister: '注册审批',

    orderMgt: '訂單管理 ',
    deposit: '入金訂單',
    payout: '代付訂單 ',
    settlement: '結算訂單',
    refund: '退款訂單',
    requestLog: '請求日誌',
    globalPayments: '全球付款',

    report: '報告中心 ',
    balance: '余額報告 ',
    transaction: '交易報告',
    rebate: '返佣報表',
    platform: '平台報表',
    upparting: '機器人上分',
    agent: '代理傭金',

    antDashboard: '首頁',
    antManage: '螞蟻管理',
    topupOrder: '充值訂單',
    cashOrder: '提現訂單',
    buyUOrder: '買U訂單',
    shopManage: '商戶管理',
    operateManage: '運營管理',
    goodsManage: '產品管理',
    operation: '運營中心',
    gcash: 'Gcash 後臺管理',
    gcashAccount: 'Gcash 賬戶管理',
    gcashGroups: 'Gcash 分組管理',
    exchangeOrder: '承兌訂單'
  },
  navbar: {
    logOut: '退出登錄',
    dashboard: '首頁',
    size: '布局大小',
    return: '返回應用面板'
  },
  admin: {
    ip: '0.0.0.0表示未設置限製。',
    password: '若需修改則輸出；否則無需輸入',
    authMgt: '授權管理',
    module: '模塊',
    menu: '菜單',
    function: '功能',
    example: '示例'
  },
  loginPage: {
    loginForm: '使用者登入',
    username: '電子郵箱',
    password: '密碼',
    code: '谷歌',
    logIn: '登入',
    thirdparty: '或者聯系',
    thirdpartyTips: '本地無法模擬，請結合您自己的業務模擬！ ！ ！'
  },
  application: {
    applicationPanel: '應用程式面板',
    myApplication: '我的應用程式',
    addApplication: '創建應用程式',
    describe1: '還能再創建',
    describe2: '個支付應用',
    describe3: '個',
    logOut: '退出',
    edit: '編輯',
    applicationName: '應用名稱 ',
    holder: '請輸入應用名稱 ',
    status: '狀態',
    availableCurrency: '可用貨幣 ',
    close: '關閉',
    create: '創建',
    save: '保存',
    editApplication: '編輯應用程序',
    type: '平臺類型',
    payment: '支付系统',
    ant: '螞蟻系統'
  },
  header: {
    currentApplication: '當前的應用程式',
    currentTime: '當前時間',
    currentUser: '當前用戶'
  },
  dashboard: {
    sort: '序号',
    merchantNo: '商戶號',
    productName: '產品名',
    productAccount: '產品帳戶',
    select: '搜索',
    reset: '重置',
    deposit: '存款',
    withdraw: '提款',
    settlement: '结算',
    balance: '餘額',
    abnormalOperation: '異常操作',
    amount: '金額',
    volume: '數量',
    fee: '手續費',
    pendingPayoutAmount: '在途代付金額',
    succeededPayoutAmount: '成功代付金額',
    payoutFee: '代付手續費',
    pendingSettlementAmount: '在途結算金額',
    succeededSettlementAmount: '成功結算金額',
    settlementFee: '結算費用',
    pending_refund_amount: '在途退款金額',
    succeed_refund_amount: '成功退款金額',
    refund_fee: '退款手續費',
    change_refund_order_amount: '修改的退款訂單',
    totalAmount: '總金額',
    succeededAmount: '成功的金額',
    totalTransaction: '交易總金額',
    succeededTransaction: '成功交易',
    conversionRate: '兌換率',
    changeDepositOrder: '修改的入金訂單',
    changePayoutOrder: '修改的代付訂單',
    changeSettlementOrder: '修改的結算訂單',
    manualIncreaseBalance: '手動增加餘額',
    manualDecreaseBalance: '手動減少余額',
    hint1: '當前時間段沒有數據',
    transactionAmountuests: '交易金額',
    rank: '排名',
    productProportion: '入金產品交易統計',
    productAccountProportion: '入金產品賬戶交易統計',
    totalBalance: '總余額',
    merchantBalance: '商戶余額',
    collection: '螞蟻總余額',
    product_code: '产品名称',
    succeed_amount: '交易金额',
    succeed_volume: '成功笔数',
    succeed_rate: '成功率',
    account_name: '账户名称',
    account_type: '账户类型',
    depositStatistics: '产品统计',
    depositAccountStatistics: '账户统计',
    totalTransact: '交易总数',
    depositStat: '入金统计',
    tooltip: '点击展示更多数据',
    downloadType: '請選擇導出的類型',
    depositExport: '入金導出',
    withdrawExport: '出金導出',
    available_balance: '可用余額',
    total_available_balance: '總可用余額',
    subProductList: '子產品統計',
    product_name: '產品名稱',
    sub_product_name: '子產品名稱',
    contains_sub_products: ' (包含子產品)',
  },
  manager: {
    userName: '用戶名稱',
    select: '搜索',
    reset: '重置',
    export: '導出',
    currentDevice: '當前設備',
    OtherDevice: '其他設備',
    managerType: '管理員類型',
    ipWhiteList: 'IP白名單 ',
    placeholder: '請輸入IP',
    editIP: '編輯 IP白名單',
    resetIp: '重置 IP白名單',
    availableCurrency: '可用貨幣 ',
    status: '狀態',
    active: '啟用',
    inactive: '未啟用',
    block: '锁定',
    disable: '禁用',
    operation: '操作',
    passWord: '密碼',
    email: '電子郵件',
    admin: 'admin',
    manager: '管理員',
    send_email: '發送電子郵件',
    login_password_changed: '强制商户修改登录密码',
    withdraw_password_changed: '强制商户修改提现密码',
    yes: '是',
    no: '否',
    merchant_domain: '商戶後臺域名',
    ant_product_account_group: '螞蟻代付組',
    checkout_counter_domain: '收銀臺域名',
    currency_timezone_map: '貨幣時區',
    taskDescription: '任務敘述',
    GoogleCode: '谷歌代碼',
    close: '關閉',
    save: '保存',
    createdBy: '創建者',
    startPlaceholder: '創建開始時間',
    endPlaceholder: '創建結束時間',
    createdTime: '創建時間',
    description: '敘述',
    add: '添加 ',
    merchantNo: '商戶號 ',
    merchantName: '商戶名稱 ',
    name: '名稱',
    balance: '余額',
    edit: '編輯',
    del: '刪除',
    createMerchant: '創建商戶 ',
    delMerchant: '刪除商戶',
    basicInformation: '基本信息 ',
    password: '密碼',
    phone: '電話 ',
    pinForWithdraw: '提現密碼',
    remarks: '備註',
    introduceAgent: '上級代理',
    modify: '修改',
    safetyInformation: '安全信息',
    merchantKey: '商戶密鑰',
    depositNotifyURL: '存款通知地址',
    content1: '1. URL 必須以 http 或 https 開頭，不允許查詢字符串。',
    content2: '2. URL 支持模板變量： ',
    content3: '-merchant_ref（商戶訂單號），格式為 ',
    content4: '-產品，格式為 ',
    content5: '例如：',
    content6: '假設商家訂單號為123456，商品為ThaiQR ',
    content7: 'URL 地址為 https://your_domain.com/path1/',
    content8: '最終請求的地址是 ',
    returnURL: '返回的地址',
    withdrawNotifyURL: '提現通知地址',
    IPWhiteList: 'IP 白名單 ',
    gogleAuth: '谷歌身份驗證',
    pass_notify_url: '傳參是否攜帶異步地址',
    allow_merchant_set_IP_whitelist: '商户配置IP白名单',
    cancel: '取消 ',
    createNext: '創建/下一步 ',
    editMerchant: '編輯商戶',
    batchEditProduct: '批量修改商戶產品配置',
    productManage: '產品管理',
    agentProductManage: '代理產品管理',
    accountsBalance: '帳戶余額 ',
    settlementAccounts: '结算帳戶',
    depositOrder: '入金訂單',
    payoutOrder: '代付訂單',
    settlementOrder: '结算訂單',
    manager1: '管理員',
    productList: '產品列表',
    productType: '產品類型',
    productName: '產品名稱',
    accountSelect: '查詢賬戶',
    settlementLimit: '結算限額',
    settlement: '單筆金額',
    small_fee: '小额手续费',
    settlementTime: '結算時間',
    depositTime: '入金時間',
    fee: '手續費',
    limits: '单笔限製',
    limit: '限製',
    availableTime: '有效時間',
    merchantProduct: '商戶產品',
    productAccount: '产品帳戶 ',
    currency: '貨幣',
    tiShi: '該產品沒有帳戶組，請選擇其他產品 ',
    tiShi2: '請先選擇產品',
    tiShi3: '請選擇時間段',
    tiShi4: '請先創建產品賬戶',
    tiShi5: '該產品沒有賬戶組，請選擇其他產品賬戶',
    productAccountGroup: '產品帳戶組',
    create: '創建',
    agentProduct: '代理產品',
    agentPrice: '代理價格',
    introducedMerchantsList: '介紹商戶列表',
    startTime: '開始時間 ',
    endTime: '時間結束 ',
    depositAmount: '入金金額',
    depositCommission: '入金傭金',
    payoutAmount: '代付金額',
    payoutCommission: '代付傭金',
    settlementAmount: '結算金額',
    settlementCommission: '結算傭金',
    resigersTime: '註冊時間',
    rate: '比率',
    settledRebate: '已结算回扣',
    unsettledRebate: '未结算回扣',
    amount: '金額',
    exchangeRate: '匯率 ',
    currentBalance: '當前余額',
    availableBalance: '可用余額',
    outstandingDeposit: '在途入金',
    pendingSettlement: '在途结算',
    pendingPayouts: '在途代付',
    adjustBalance: '調整余額',
    direction: '方向 ',
    decrease: '減少',
    increase: '增加',
    accountsStatement: '帳戶報表',
    cause: '原因 ',
    orderNumber: '訂單號',
    minAmount: '最小金額',
    maxAmount: '最大金額',
    beforeBalance: '之前的余額',
    afterBalance: '之后的余額',
    test_order: '管理員補單',
    pay_time_duration: '支付用時（分鐘）',
    sourceIP: '源IP ',
    reserve_balance: '保证金',
    reserve_balance_config: '保证金配置',
    reserve_rate: '费率',
    systemRef: '平臺訂單號',
    createExchangeRate: '創建匯率 ',
    editExchangeRate: '編輯匯率 ',
    basicCurrency: '基本貨幣 ',
    quoteCurrency: '報價貨幣',
    mode: '模式',
    bid: '賣價',
    ask: '買價',
    bankAccounts: '銀行帳戶 ',
    information: '信息 ',
    bankAccount: '銀行帳戶 ',
    bankCode: '銀行代碼',
    accountName: '用戶名稱',
    accountNo: '帳戶號',
    volume: '數量',
    created: '創建',
    unpaid: '未付款',
    success: '成功',
    successful: '成功的',
    depositOrderList: '入金訂單列表',
    callbackType: '回調類型',
    notifyStatus: '通知狀態',
    notifyStartTime: '通知開始時間',
    notifyEndTime: ' 通知結束時間',
    unfreezeStartTime: '凍結開始時間',
    unfreezeEndTime: '凍結結束時間',
    instruction: '操作說明',
    merchantRef: '商戶訂單號',
    productRef: '產品訂單號',
    requestAmount: '請求金額',
    paidAmount: '支付金額',
    productStatus: '產品狀態',
    notifiedTime: '通知時間 ',
    pendingAmount: '待交易金額',
    pendingTransaction: '待處理交易',
    successAmount: '成功金額',
    successTransaction: '成功交易',
    freezeAmount: '凍結金額 ',
    freezeTransaction: '凍結交易 ',
    rejectAmount: '拒絕金額',
    rejectTransaction: '拒絕交易',
    payoutOrderList: '代付訂單列表',
    source: '来源 ',
    bankName: '銀行名稱',
    approvedTime: '審批時間',
    settlementOrderList: '結算訂單',
    userManagement: '用戶管理 ',
    username: '用戶名 ',
    noData: '沒有數據 ',
    attach: '附加',
    attachEdit: '編輯附加',
    loginLog: '登錄日誌',
    operation_type: '操作類型',
    change_balance: '調整余額',
    freeze_balance: '凍結余額',
    accountPhone: '賬戶電話',
    agency: '下級代理',
    refund_min_fee: '退款手續費',
    pending_refund_balance: '在途退款',
    today_pending_settlement_balance: '今日可结算',
    balance_type: '余額類型',
    feeSetting: '手續費設置',
    amountLimit: '金額限製',
    team: 'GCash管理員',
    cardManager: '卡商管理员',
    device_id: '设备 ID',
    os: '系统类型',
    os_version: '系统版本',
    browser: '浏览器名称',
    family: '设备类型',
    brand: '设备品牌',
    location: '地址',
    new: '新設備',
    apply_from: '登陸方式',
    apply_by: '運維管理員',
    belive: '信任此設備',
    device_info: '客戶設備',
    Email: '郵箱驗證碼',
    seconds: '秒後重新獲取',
    get_code: '獲取驗證碼',
    card_3d: '信用卡3D',
    hongKongHost: '使用香港Host',
    is_bank: '银行校验',
    card_config: '信用卡限製',
    period: '周期(小時)',
    count: '次數'
  },
  taskCenter: {
    approved_by_name: '审批人',
    select: '搜索',
    reset: '重置',
    export: '導出',
    productName: '產品名稱 ',
    createdBy: '創建者',
    approvedBy: '審核者',
    status: '狀態',
    startPlaceholder: '創建開始時間',
    endPlaceholder: '創建結束時間',
    handleStartTime: '處理開始時間',
    handleEndTime: '處理結束時間',
    timeType: '時間類型',
    title: '標題',
    description: '敘述',
    content: '內容',
    expectStatus: '期望狀態',
    approval: '批準',
    approvalMany: '批準許多',
    Reject: '拒絕',
    createdTime: '創建時間',
    lasteTime: '最後活躍時間',
    updateTime: '更新時間',
    successTime: '成功時間',
    approveTime: '審批時間',
    handleTime: '處理時間',
    operation: '操作',
    review: '審核',
    googleQRCode: '谷歌二維碼 ',
    download: '下載',
    googleCode: '谷歌代码 ',
    cancel: '取消',
    confirm: '確定',
    pendingAmount: '待交易金額：',
    pendingTransaction: '待處理交易：',
    fee: '手續費：',
    fee1: '手續費',
    successAmount: '成功金額：',
    successTransaction: '成功交易：',
    freezeAmount: '凍結金額： ',
    freezeTransaction: '凍結交易： ',
    rejectAmount: '拒絕金額：',
    rejectTransaction: '拒絕交易：',
    order_number: '訂單號 ',
    child_ordernumber: '出金訂單號',
    merchant_no: '商戶號 ',
    min_amount: '最小金額',
    max_amount: '最大金額',
    min_coin: '最小鏈幣',
    max_coin: '最大鏈幣',
    source: '來源 ',
    product_account_group: '產品組',
    upstream_status: '產品狀態',
    startPlaceholder1: '創建開始時間 ',
    endPlaceholder1: '創建結束時間 ',
    startPlaceholder2: '成功開始時間 ',
    endPlaceholder2: '成功結束時間 ',
    batchPaid: '批量支付',
    openPayfor: '一键代付',
    batchModifyStaus: '批量更改',
    merchantRef: '商戶訂單號',
    systemRef: '平台訂單號',
    depositId: 'ID',
    productRef: '產品訂單號',
    amount: '金額',
    information: '信息',
    states: '狀態',
    notifyStatus: '通知狀態 ',
    notifiedTime: '通知時間 ',
    Approval: '審批',
    callback_amount: '期望金额',
    Change: '更改',
    Query: '查詢',
    ChangeOrder: '改變訂單狀態',
    Details: '詳細說明',
    OrderDetails: '訂單詳情',
    billDetails: '賬單詳情',
    accountName: '帳戶名',
    accountNo: '帳戶號',
    bankCode: '銀行代碼',
    address: '地址',
    coinType: '硬幣類型',
    product: '产品',
    productAccount: '產品名稱',
    selectProduct: '請先選擇產品 ',
    success: '成功',
    pending: '等待',
    rejected: '被平臺拒絕',
    remarks: '備註',
    taskDescription: '任務描述',
    orderInformation: '訂單資訊',
    merchantsDetail: '商戶明細',
    accountsStatnment: '賬戶報表',
    interfaceInformation: '接口信息 ',
    notify: '通知 ',
    currency: '貨幣',
    productStatus: '產品狀態 ',
    productInformation: '產品信息 ',
    productAccountName: '產品帳戶名稱',
    productAccountNo: '產品帳戶',
    productAccountType: '產品帳戶類型 ',
    Upstream: '上遊',
    Downstream: '下遊',
    notifyURL: '異步回調地址',
    returnURL: '同步回調地址',
    requestTime: '请求时间',
    notifyTime: '請求時間',
    notifyBody: '通知內容',
    request: '請求報文',
    response: '響應報文',
    Key: '字段鍵值',
    Value: '內容值',
    notifyRequest: '通知請求 ',
    notifyResponse: '通知響應',
    orderNumbers: '訂單號',
    withdrawRef: '出金訂單號',
    fundInformation: '存款信息',
    rquestAmount: '申請的金額 ',
    paidAmount: '支付的金額',
    Attach: '附加',
    direction: '方向',
    exceptionType: '異常類型 ',
    batchReview: '批量審核 ',
    startId: '起始 ID',
    endId: '结束 ID',
    startHolder: '請輸入起始 ID',
    endHolder: '請輸入结束 ID',
    type: '類型 ',
    reason: '理由',
    associatedOrderNumber: '相關訂單號',
    batchModifyOrderStatus: '批量修改訂單狀態',
    batchModifyFreezeOrder: '批量修改凍結訂單',
    batchOrderNotify: '批量通知',
    openKickOut: '踢出队列',
    message: '消息',
    queryOrder: '查詢訂單信息',
    orderInfoHolder: '輸入商戶訂單號查詢訂單詳情',
    orderInfoHolder1: '默认按订单金额处理，填写后按期望金额处理',
    noData: '目前沒有數據',
    event: '事件',
    selectMethod: '選擇處理方式',
    merchantOrder: '回調訂單',
    accountBalance: '增加余額',
    merchantNo: '商戶號',
    accountStatement: '帳戶報表',
    action: '處理模式',
    freeze_duration: '凍結持續時間（分鐘）',
    instruction: '操作說明',
    reverse_order: '沖正訂單',
    reversal: '沖正',
    gateway_url: '網關地址',
    field: '錢包地址',
    range: '金额范围',
    rangeDate: '时间范围',
    queryParams: '查询参数',
    multiple_order_number: '多个订单号',
    multipleOrderTips1: '当前',
    multipleOrderTips2: '个订单号',
    multipleOrderTips3:
      '，添加新的訂單號請在當前最後一個訂單號後面用英文逗號分割',
    multipleOrderTips4:
      '請將多個訂單號在 Excel 或者 TXT 排成一列，然後復製粘貼到該輸入框',
    OneClickChange: '一键更改',
    OneClickUnfreeze: '一键解凍',
    multi_child_ordernumber: '多個出金訂單號',
    rate: '轉化率',
    total_volume: '充值金額',
    total_count: '充值訂單',
    uncollect_amount: '未歸集金額',
    success_volume: '成功金額',
    success_count: '成功訂單',
    childOrder: '子訂單',
    withdrawal: '提現設置',
    walletId: '多個錢包 ID',
    refund_order: '入金訂單號',
    cap_status: 'CAP 狀態',
    mode: '混卡批量審核',
    time: '混卡時間設置'
  },
  product: {
    category: '商戶類別代碼',
    name: '名稱',
    currency: '貨幣',
    productType: '產品類型',
    product: '產品',
    status: '狀態',
    accounts: '帳戶',
    operation: '操作',
    edit: '編輯',
    del: '刪除',
    cashierDeskConfiguration: '收銀臺配置',
    noData: '當前產品收銀臺沒有可配置項',
    bankDeskConfiguration: '前臺銀行配置',
    subProduct: '子產品手續費',
    close: '關閉',
    modify: '修改',
    cashierConfig: '添加收銀臺配置',
    cashierEditConfig: '編輯收銀臺配置',
    accountType: '帳戶類型',
    coin_balance: '主鏈幣余額',
    bankCode: '銀行代碼',
    bnakName: '銀行名稱',
    logo: '銀行圖標',
    editProductBank: '編輯產品的銀行',
    priority: '優先',
    add: '添加',
    onlineState: '在線狀態 ',
    accountNo: '帳戶號',
    accountName: '帳戶名称',
    accountGroup: '帳戶組',
    active: '启用',
    inactive: '未启用',
    block: '锁定',
    wait: '待审核',
    reject: '已驳回',
    approve: '审核通过',
    rejectApprove: '审核驳回',
    disable: '禁用',
    select: '搜索',
    reset: '重置',
    limits: '限製',
    dailyLimitedVolume: '每日限定交易金額',
    availableVolume: '可用交易金額',
    dailyLimitedTransaction: '每日限定交易筆數',
    availableTransaction: '可用交易筆數',
    today_deposit_amount: '今日收款金額',
    margin_balance: '保證金余額',
    hook_start_time: '接單開啟時間',
    daily_rate: '成功率',
    matching: '匹配訂單',
    hookBalance: '上遊余額',
    dedicatedMerchant: '專用商戶',
    createProductAccount: '創建產品帳戶',
    basicInformation: '基本信息 ',
    transaction: '交易',
    statistical: '帳戶統計',
    productName: '產品名稱',
    pollingWeight: '轮询权重',
    collectAddress1: '歸集地址',
    collectAddress2: '代付錢包',
    SystemAmount: '系統交易金額',
    manual_amount: '手動金額',
    collect_amount: '歸集金額',
    consume: '消耗 TRX',
    abnormal_txn: '異常交易',
    abnormal_txn_count: '異常交易數量',
    productAccountGroup: '產品帳戶組',
    remarks: '備註',
    back: '後退',
    createNext: '創建/下一步 ',
    configuration: '配置',
    click: '點擊',
    info: '查看幫助說明',
    create: '創建',
    clear: '清除',
    saveNext: '保存/下一步 ',
    pleaseSelect: '請選擇',
    createWallet: '創建錢包',
    limitation: '限製',
    availableTime: '可用時間',
    selectTimeRange: '請選擇時間段',
    limit: '限製',
    queryFrequency: '轮询频率',
    frequencyTips: '開啟輪詢,默認頻率為1分鐘',
    save: '保存',
    editAccount: '編輯帳戶',
    statistics: '統計數據',
    todayVolume: '今日成交量 ',
    todayAvailableVolume: '今日可用量 ',
    todaySuccessTransaction: '今日成功交易 ',
    todaySuccessfulRate: '今日成功率 ',
    totalVolume: '全部成交量',
    totalTransaction: '交易總額 ',
    orderDetails: '訂單詳細信息 ',
    systemRef: '平臺訂單號',
    merchantRef: '商戶訂單號',
    notifyStatus: '通知狀態',
    createdStartTime: '創建開始時間 ',
    createdEndTime: '創建結束時間 ',
    merchantNo: '商戶號',
    prePayAmount: '預付金額 ',
    paidAmount: '已付金額 ',
    createdTime: '創建時間 ',
    notifiedStatus: '通知狀態 ',
    walletAddress: '錢包地址',
    payment_wallet: '付款錢包',
    privateKey: '個人密鑰',
    productAccount: '產品帳戶',
    weight: '輪詢權重',
    quanzhong: '請選擇產品賬戶',
    tiShi: '該產品沒有帳戶，請選擇其他產品 ',
    hoder: '請輸入帳戶組名 ',
    collectionlog: '錢包地址收集日誌 ',
    fromAddress: '從當前地址',
    toAddress: '到當前地址',
    transactionID: '交易編號',
    productRef: '產品訂單號',
    message: '消息',
    account_name: '賬戶名稱',
    account_no: '賬戶號',
    user_id: '設備名稱',
    from_val: '來源',
    createtime: '創建時間 ',
    creatingAccountGroup: '創建帳戶組 ',
    editAccountGroup: '編輯帳戶組 ',
    amount: '金額',
    uncollectedAmount: '未歸集金額 ',
    coinAmount: '未歸集主鏈幣金額',
    address: '地址',
    balance: '余額',
    collectionLog: '收集日誌',
    extraParam: '產品配置',
    productPluginConfig: '產品插件配置',
    register_switch: '注册开关',
    register_apply_switch: '注册审核开关',
    notAllowed: '不允许注册',
    allow: '允许注册',
    notNeed: '不需要审核',
    need: '需要审核',
    extraParam1: '出金隊列',
    extraParam2: 'UPI 超時時間設置',
    extraParam3: '共享代付賬戶',
    share_payout_account: '開啟共享代付賬戶',
    skipQueue: '不用排队',
    setTimeout: '開啟回調超時',
    open: '打開',
    setTime: '超时设置(秒)',
    timeoutTisp: '默認是30分鐘，即1800秒',
    frequency: '頻率(秒)',
    bill: '每次出金筆數',
    frequency1: '頻率(分鐘)',
    api_key: 'API Key',
    cannot: '開啟狀態，頻率不能為0',
    not_display_qrcode: '不顯示二維碼',
    floating_amount: '金額浮動下限',
    not_display_qrcode1: '商戶不顯示二維碼',
    not_display_qrcode2: '應用不顯示二維碼',
    jump_checkout_counter_mode: '跳轉收銀臺模式',
    checkout_counter_mode: '收銀臺模式',
    server: '服務器',
    rate: '比率',
    volume: '數量',
    success_volume: '成功數量',
    emptyMerchant: '清空專用商戶',
    addApikey: '添加API Key',
    stakeWallet: '自动質押',
    stakeRecord: '手动質押',
    receiver_name: '接收賬戶',
    resource: '資源',
    energy: '能量',
    bandwidth: '带宽',
    fee_saving: '節約手續費',
    frozen_balance: '質押數量(Trx)',
    freeze: '凍結',
    unfreeze: '解凍',
    unfreezing: '解凍進度',
    isunfreeze: '解凍中',
    unfreeze_percent: '解凍比例',
    cause: '原因',
    buy_unfreeze: '够买解冻',
    buy_unfreeze1: '够买冻结',
    topup_unfreeze: '充值解冻',
    topup_unfreeze1: '充值冻结',
    freeze_percent: '凍結比例',
    totalAmountFreezeend: '总凍結金额',
    expectedThawing: '预计解凍金额',
    expectedFreeze: '预计冻结金额',
    failed: '失敗',
    unfreezeend: '已解凍',
    freeze_txn_id: '質押交易 ID',
    product_code: '產品',
    product_account_name: ' 产品账户名',
    createPledge: '創建質押',
    unfreezePledge: '解凍質押',
    unfreeze_time: '解凍時間',
    get: '獲得',
    product_detail: '產品詳情',
    work_dir: '工作目錄',
    Log: '日誌',
    program: '進程名稱',
    pid: '進程 ID',
    start_plug: '啟動',
    reload_plug: '重啟',
    stop_plug: '停止',
    unlock_plug: '查詢',
    add_btn: '新增',
    apply_view_log: '查看日誌',
    change_pin: '修改Pin',
    prompt: '提示',
    otp: 'OTP 驗證碼',
    otpTips: 'OTP 标识',
    automatic_payment: '自動代付',
    can_withdraw_balance: '可提現金額',
    frozen: '提取凍結金額',
    extract: '提取',
    pledge: '質押',
    agency: '代理',
    accout: '代理賬戶',
    Address: '代理地址',
    type: '代理類型',
    number: '代理數量(Trx)',
    principal: '可提取的質押本金',
    sleep: '停止查單',
    notify_after_collect: '歸集後回調',
    last_collect_time: '上次歸集時間',
    change_tiem: '編輯時間',
    amount_timeout: '浮動金額鎖（分鐘）',
    review: '螞蟻賬戶',
    coin_type: '地址類型',
    active_time: '驗證碼有效時長（分鐘）',
    sms_message: '短信模版',
    note: '註: 短信模版驗證碼占位符 {{code}}',
    sms_edit: '短信配置',
    expiration_time: '設置過期時間',
    cashier: '設置收銀臺過期時間',
    queueType: '隊列類型',
    unify: '統壹排隊時間',
    separate: '分開設置時間',
    separateQueues: '分開設置隊列',
    utrWeight: 'UTR輪詢排序',
    utrWeight1: '請依次選擇賬戶進行排序',
    product_sub_switch: "是否啓用",
    product_sub_code: '子產品',
    product_sub_info: '子產品費用详情',
    product_sub_fee: '子產品費用',
    sub_rate: '費率',
    min_fee: '最小費用',
    fixed_fee: '固定費用',
    max_amount: '最大金額',
    min_amount: '最小金額',
    addSubConfig: '添加費率配置',
    delete: ' 刪除',
    amount_range_error: '最大金額必須大於等於最小金額',
    amount_continuity_error: '最小金額必須大於前一項的最大金額',
    fee: '手續費',
    gateway_transaction_fee: '网关手续费',
  },
  test: {
    product: '產品',
    productAccount: '產品帳戶',
    selectProduct: '請先選擇產品 ',
    amount: '金額',
    extra: '額外參數',
    merchant: '商戶號',
    tips: '請輸入商戶號',
    tips1: '請選擇支付方式',
    tips2: '請選擇交易所',
    is_api_integrate: '集成API：1，收銀臺：0',
    subTips1: 'API 直連模式：',
    subTips2: '必須選擇子產品，並填寫對應的額外參數。',
    subTips3: '收銀臺模式：',
    subTips4: '請不要選擇子產品。',
  },
  download: {
    relatedSoftware: '相關軟件 '
  },
  report: {
    merchantNo: '商戶號 ',
    startTime: '開始時間',
    endTime: '結束時間',
    select: '搜索',
    reset: '重置',
    export: '導出',
    date: '日期',
    merchantName: '商戶名稱 ',
    openingBalance: '期初余額',
    endingBalance: '期末余額 ',
    startingPendingBalance: '開始等待的余額',
    endingPendingBalance: '結束等待的余額',
    type: '類型 ',
    amount: '金額',
    volume: '數量',
    fee: '手續費',
    manualInterventionVolume: '手動幹預數量',
    manualInterventionAmount: '手動幹預金額',
    manualInterventionTransaction: '手動幹預交易',
    begin: '開始',
    end: '結束',
    productName: '產品名稱',
    currency: '貨幣',
    product: '產品',
    transactionVolume: '交易量',
    rebate: '返傭',
    count: '人數',
    level: '等級',

    new_ant_account: '新增賬戶',
    first_topup_when_register: '注冊當日充值賬戶',
    first_topup_ant_account_when_register: '注冊當日充值金額',
    active_ant_account: '活躍賬戶',
    topup_ant_account: '當日充值賬戶',
    topup: '當日充值金額',
    first_topup_ant_account: '首充賬戶',
    first_topup: '首充金額',
    withdraw: '提現金額',
    sale_usdt: '銷售金額',
    invitation_rebate: '好友返傭',
    sale_profit: '銷售收益',
    succeed_deposit_amount: '商戶入金',
    deposit_fee: '入金手續費',
    succeed_deposit_volume: '入金成功筆數',
    succeed_payout_amount: '商戶出金',
    payout_fee: '出金手續費',
    succeed_payout_volume: '出金成功筆數',
    balance: '商戶總余額',
    active_agent: '活躍代理賬戶',
    new_descendant: '下級註冊賬戶',
    descendant_first_topup_count: '下級新充賬戶',
    descendant_first_topup_amount: '下級新充賬戶金額',
    create_time: '創建時間',
    exchange: '兌換數據',
    upper: '上分數據',
    risk: '風險控製',
    nickname: '發圖人昵稱',
    coin_id: '安幣 ID',
    upper_limit: '上分上限',
    unit_quantity: 'U數量',
    rupee_quantity: '盧比數量',
    exchange_rate: '匯率',
    pay_type: '支付方式',
    name: '賣家姓名',
    order_time: '訂單時間'
  },
  setting: {
    manageBackEndDomain: '管理員管理域名',
    merchantBackEndDomain: '商戶端域名',
    checkoutCounterDomain: '收銀臺域名',
    modify: '修改',
    siteName: '網站標題',
    siteLogo: '網站 Logo',
    testMerchantNo: '測試商戶號',
    googleAuthentication: '谷歌身份驗證',
    botGoogleAuthentication: '機器人谷歌驗證',
    addExchangeRate: '創建匯率',
    baseCurrency: '基礎貨幣',
    quoteCurrency: '報價貨幣',
    mode: '模式',
    bid: '賣價',
    ask: '買價',
    operation: '操作',
    edit: '編輯',
    delete: '刪除 ',
    back: '取消',
    save: '保存',
    cancel: '取消',
    create: '創建',
    editMerchantNo: '編輯商戶號 ',
    taskDescription: '任務描述',
    editCheckoutCounterDomain: '編輯收銀臺域名 ',
    editExchangeRate: '編輯匯率 ',
    notify_switch: '代付聲效開關',
    auto_refund: '自動退款開關',
    ant_payout_payment_switch: '螞蟻代付搶單',
    notify_withdraw_switch: '出金審查任務通知',
    notify_usdt_collect_switch: 'USDT 通知開關',
    thai_notify_switch: 'Thai 通知開關',
    inr_notify_switch: 'INR 通知開關',
    php_notify_switch: 'PHP 通知開關',
    eur_notify_switch: 'EUR 通知開關',
    ngn_notify_switch: 'NGN 通知開關',
    rm_notify_switch: 'RM 通知開關',
    safety_notify_switch: '安全通知开关',
    gcash_notify_switch: 'GCash 防盜刷通知開關',
    gcashTgTitle: 'Telegram GCash 防盜刷通知',
    usd_cap_notify_switch: 'CAP 異常通知',
    usd_cap_notify_telegram_group: 'Telegram CAP 異常通知',
    ant_limit_notify_switch: '螞蟻上分上限通知',
    ant_register_notify_switch: '螞蟻注册通知',
    ant_limit_notify_telegram_group: 'Telegram 螞蟻上分上限通知',
    addGroup: '添加 Telegram 通知群組',
    payTgTitle: 'Telegram 代付通知',
    usdtTgTitle: 'Telegram USDT 通知',
    thaiTgTitle: 'Telegram Thai 通知',
    inrTgTitle: 'Telegram INR 通知',
    phpTgTitle: 'Telegram PHP 通知',
    eurTgTitle: 'Telegram EUR 通知',
    ngnTgTitle: 'Telegram NGN 通知',
    groupId: 'Telegram 群ID',
    inputGroupId: '請輸入群ID',
    inputGroupId1: '请输入群ID、账户类型（使用英文分号间隔）',
    inputQueryId: '请输入群名称查詢群ID',
    queryBtn: '查詢',
    telegram_robot_token: 'Telegram 客服機器人 Token',
    telegram_devops_robot_token: 'Telegram 運維機器人 Token',
    setTimeZone: '货币时区',
    tab1: '系統設置',
    tab2: '運維機器人',
    tab3: '客服機器人',
    tab4: '基礎設置',
    tab5: '返傭設置',
    tab6: '推薦返傭',
    tab7: '賬戶轉發',
    tab8: 'FP機器人',
    ant_withdraw_max_order_count: '螞蟻搶單限製數',
    ant_withdraw_expire_min: '螞蟻搶單失效時間(分鐘)',
    buy_usdt_rate: 'Buy USDT 匯率',
    rateBuyLog: 'Buy USDT 匯率設定',
    buy_freeze: 'Buy 冻结设置',
    sale_usdt_rate: 'Sale USDT 匯率',
    rateSakeLog: 'Sale USDT 匯率設定',
    baseFreeze: '代收本金凍結',
    baseFreezeLog: '防止用戶在沒有成交代付的情況，凍結金額（小時)',
    exchangeFreezeLog: '防止用戶在沒有成交承兌的情況，凍結金額（小時)',
    sale_usdt_rebate_rate: 'Sale USDT返傭',
    buy_usdt_rebate_rate: 'Buy USDT返傭',
    sale_rebate_freeze_time: 'Sale USDT傭金凍結時間',
    buy_rebate_freeze_time: 'Buy USDT傭金凍結時間',
    exchange_usdt_rebate_rate: 'Exchange USDT返傭',
    exchange_rebate_freeze_time: 'Exchange USDT傭金凍結時間',
    rebateRateLog:
      '訂單交易成功後給上級返傭的比例0 - 100，例：5=反訂單金額的5%',
    rebateRateAnt:
      '訂單交易成功後給螞蟻返傭的比例0 - 100，例：5=反訂單金額的5%',
    freezeTime: '傭金凍結時間',
    in_maintain: '不可用銀行',
    freezeTimeLog: '防止用戶退款，傭金提現了，所以需要設置傭金凍結時間（天）',
    yiji: '一級返傭比例',
    erji: '二級返傭比例',
    sanji: '三級返傭比例',
    safety: '安全通知開關',
    safetyTg: 'Telegram 安全通知',
    kefu_link: '客服鏈接',
    topup_freeeze: '充值冻结',
    wallet_reset_duration: '充值地址使用时长（年）',
    close_buy: '代付功能',
    ant_trc20: 'TRC20 控製開關',
    ant_erc20: 'ERC20 控製開關',
    ant_inr: 'INR 控製開關',
    wallet_delete_switch: '刪除賬戶',
    test_order_notify_switch: '測試訂單通知',
    telegram_account_switch: '消息转发',
    fee: '提現手續費',
    trc_fee: 'TRC20 提現手續費',
    erc_fee: 'ERC20 提現手續費',
    clave_notify_switch: 'Clave 識別',
    buy_platform_usdt_rate: '法幣買U匯率',
    buy_platform_usdt_min_amount: '法幣買U最低金額',
    merchant_deposit_settlment_rate: '商戶入金匯率',
    merchant_payout_settlment_rate: '商戶代付匯率',
    merchant_exchange_settlment_rate: '商戶承兌匯率',
    ant_google_auth: '螞蟻提現谷歌驗證',
    open: '開啟驗證',
    close: '關閉驗證',
    send: '發送密鑰',
    reset: '重置密鑰',
    photo: '圖片識別',
    asyn_photo_switch: '异步圖片識別',
    api_error_switch: 'API報錯通知',
    api_sms_switch: 'SMS 通知',
    rm_deposit_notify_switch: 'RM 代收开关',
    rm_payout_notify_switch: 'RM 代付开关',
    rm_collect_notify_switch: 'RM 归集开关',
    score: '上分識別',
    cars_switch: '混卡模式',
    bot_cars_switch: '混卡模式',
    bot_cars_setting: '上分時間段設置',
    bot_cars_edit: '上分時間段編輯',
    app_setting: 'APP系統通知',
    choose_ant: '螞蟻賬號',
    content: '通知內容',
    send_content: '發送通知',
    record: '通知記錄',
    switch: '開關',
    off: '不開啟',
    required: '必填',
    optional: '選填',
    account_rate_notify_switch: '賬戶成功率驟降通知',
    bot_cert_style: '憑證樣式',
    merchant_no_list: '商户组',
    merchantPlaceholder: '支持多个商户号，英文逗号分割',
    errorMessage: '格式有误，也许是因为使用了不正确的英文逗号，请检查',
    delicacy: '精致',
    simple: '簡約',
    change_style: '修改憑證樣式',
    holiday: "节假日结算延期",
    days: '天数',
    holidayConfig: '添加节假日延期结算配置',
    holidayName: '节假日名称',
    fp_robot_token: 'FP 机器人 Token',
    fp_bot_switch: '查单开关',
    exchange_switch: '换汇开关',
    fp_chat_id: '群ID',
    fp_exchange_markup: '汇率',
    fp_merchant_id: '商户ID',
    fp_merchant_app_id: 'APP ID',
    fp_merchant_api_key: 'API Key',
    payout_risk_duplicate_account_switch: '风控开关',
    payout_risk_duplicate_account_window_hours: '收款账号重复出金（小时）',
    payout_risk_duplicate_account_max_count: '收款账号重复次数',
    merchant_login_google_auth_switch: '商户登录谷歌验证',
    merchant_backoffice_payout_switch: '商户后台代付/结算开关'

  },
  order: {
    total: '全部',
    today: '今天',
    succeedRequestAmount: '成功請求數量',
    Withdrawal: '出金审查',
    succeedVolume: '成功订单',
    succeedPaidAmount: '成功支付金額',
    volume: '數量',
    fee: '手續費',
    conversionRate: '轉化率',
    auth_code: '授權碼',
    last4: '卡後4位',
    orderNumber: '訂單號',
    merchantNo: '商戶號',
    instruction: '操作說明',
    paidAmount: '支付金額',
    a: '余額',
    b: '鏈幣余額',
    requestAmount: '請求金額',
    minAmount: '最小金額',
    maxAmount: '最大金額',
    productName: '產品名稱',
    productAccount: '產品賬戶',
    status: '狀態',
    notifyStatus: '通知狀態',
    timeType: '時間類型 ',
    createdTime: '創建時間',
    notifyTime: '通知時間',
    successTime: '成功時間',
    error_notify: '錯誤通知',
    upstream_data: '上遊數據',
    type: '接口請求',
    data: '報文',
    view: '查看',
    allTime: '创建/成功时间',
    unfreezeTime: '解凍時間',
    createdStartTime: '創建開始時間 ',
    createdEndTime: '創建结束时间 ',
    notifyStartTime: '創建結束時間',
    notifyEndTime: '通知結束時間',
    successStartTime: '成功開始時間 ',
    successEndTime: '成功結束時間',
    select: '搜索',
    reset: '重置',
    export: '導出',
    merchantRef: '商戶訂單號',
    systemRef: '平臺訂單號',
    productRef: '帳戶訂單號',
    productStatus: '產品狀態',
    operation: '操作',
    change: '修改',
    details: '詳情',
    more: '更多',
    orderDetails: '訂單詳情',
    changeOrders: '修改訂單',
    expectStatus: '期待狀態 ',
    payTime: '支付時間 ',
    selectDate: '請選擇日期 ',
    remarks: '備註',
    taskDescription: '任務描述',
    cancel: '取消 ',
    save: '保存',
    createdBy: '創建者',

    orderInformation: '訂單信息',
    billInfo: '賬單信息',

    notify: '通知',
    currency: '貨幣',
    collectStatus: '收集狀態',
    productInformation: '產品信息',
    product: '產品',
    productAccountName: '產品帳戶名',
    productAccountNo: '產品帳戶號',
    productAccountType: '產品帳戶類型',
    interfaceInformation: '接口信息',
    upstream: '上遊',
    downstream: '下遊',
    notifyURL: '異步回調地址',
    returnURL: '同步回調地址',
    requestTime: '請求時間',
    notifyBody: '通知內容',
    requestBody: '請求報文',
    key: '字段鍵值',
    value: '內容值',
    responseBody: '響應報文',
    notifyRequestBody: '通知請求報文',
    notifyResponseBody: '通知響應報文',
    collectionLog: '收集日誌',
    receipt: '交易收據',
    issueddate: '發行日期',
    paiddate: '支付日期',
    debitAccount: '借記賬戶',
    creditAccount: '信用賬戶',
    utfNo: 'UTR 號',
    payment: '支付金額',
    receiptName: '名稱',
    payStatus: '支付狀態',
    transactionStatus: '交易狀態',
    REMARKS: '备注',
    close: '关闭',
    print: '打印',
    createTime: '創建時間',
    message: '消息',

    pendingAmount: '在途金額',
    pendingTransaction: '在途交易',
    successAmount: '成功金額',
    successTransaction: '成功交易',
    freezeAmount: '凍結金額',
    freezeTransaction: '凍結交易',
    rejectAmount: '拒絕金額',
    rejectTransaction: '拒絕交易',
    information: '信息',
    approvedBy: '審批者',
    success: 'Success',
    pending: 'Pending',
    rejectedPlatform: 'Rejected By Platform',
    source: '來源',
    amount: '金額',
    refundAmount: '退款金额',
    approvedTime: '審批時間',
    notifiedTime: '通知時間',
    refundTime: '退款時間',
    bankCode: '銀行代碼',
    request: '請求',
    response: '響應',
    accountName: '帳戶名',
    accountNo: '帳戶號',
    withdrawInfo: '出金信息 ',
    bankName: '銀行名稱',
    logDetails: '請求日誌詳情',
    notifyRequest: '回調請求',
    notifyResponse: '回調響應',
    withdrawRef: '出金訂單號',
    query: '查詢',
    enqueue: '排隊',
    migrateBtn: '應用審查',
    migrateTit: '應用審查',
    notify_ordernumber: '下遊訂單號',
    upstream_ordernumber: '上遊訂單號',
    product_account_no: '賬戶號',
    test_order: '測試訂單',
    kaaz_bank: '銀行校驗查詢',
    info: '充值信息',
    setCollect: '歸集設置',
    collect_wallet: '歸集賬戶',
    fee_wallet: '手續費錢包',
    fee_limit: '手續費限製',
    min_collect_amount: '最低歸集金額',
    collect_by_stake: '質押歸集開關',
    google_code: 'Google 驗證碼',
    setting: '充值設置',
    USDTBlance: 'USDT 余額',
    money_type: '錢包類型',
    saleAmount: '銷售金額',
    commission: '傭金',
    address: '收款地址',
    gas: 'Gas 價格',
    price: '礦工費標準',
    refund: '退款金額',
    fiat_amount: '法幣金額',
    set_usdt: '結算金額',
    settlement_merchant_rate: '商戶匯率',
    settlement_rate: '螞蟻匯率',
    prepay: '成功法幣金額',
    settlement_amount: '回購金額',
    payment_card_type: '卡類型',
    card_last6: '卡号后6位',
    not: '未發起',
    pend: '發起中',
    initiate: '發起CAP',
    cap: '只有訂單狀態為成功且CAP狀態未發起或失敗的訂單才可進行CAP操作',
    ok: '確認',
    total_transaction: '總筆數',
    total_successful_rate: '總成功率',
    no_notify: '未通知',
    yes_notify: '已通知',
    upstream_amount: '承兑金额',
    ordernumber: '承兌訂單號',
    refundRemarks: '退款原因',
    refundHolder: '请输入退款金额',
    refundHolder1: '请详细说明退款原因',
    attention: '退款须知：',
    attention1: '可退款金额不能超过订单金额',
    attention2: '已结算订单将从商户余额扣除',
    attention3: '退款申请提交后无法撤销',
  },
  title: {
    share: '分享賬戶'
  },
  antManage: {
    accountId: '賬戶ID',
    EmailNickname: '郵箱/昵稱',
    email: '郵箱',
    type: '類型',
    balance: '保證金余額',
    state: '狀態',
    ancestor: '主賬戶',
    password: '密碼',
    create: '創建',
    modifyBalance: '余額',
    buy_freeze_balance: '够买冻结',
    quota: '配額',
    subaccount: '子賬戶',
    details: '詳情',
    amount: '金額',
    remarks: '備註',
    inOrOut: '增加或減少',
    attach: '圖片附件',
    operation: '操作類型',
    people: '個人資料',
    statistics: '數據統計',
    nickname: '賬戶ID / 賬戶昵稱',
    invitation_code: '邀請碼',
    transaction: '交易明細',
    collection: '好友列表',
    salesAmount: '銷售金額',
    cause: '明細類型',
    detailId: '明細ID',
    ordernumber: '系統訂單號',
    before_balance: '變動前余額',
    after_balance: '變動後余額',
    create_time: '創建時間',
    ip: '源IP',
    trader: '交易員',
    master: '主賬戶',
    sub: '子賬戶',
    payType: '支付方式',
    outStutus: '離線',
    online: '在線',
    control: '風控',
    full: '滿額',
    decrease: '減少',
    increase: '增加',
    from_ant: '轉出賬戶',
    to_ant: '轉入賬戶',
    change_balance: '調整余額',
    upstream_remarks: '訂單介紹',
    fee: '手续费',
    paid_amount: '支付金额',
    successful_rate: '成功率',
    successful_transaction: '成功笔数',
    total_transaction: '总使用额度',
    volume: '使用额度',
    registered: '註冊用戶',
    onlineUser: '在線用戶',
    last_login_time: '上次登錄時間',
    last_login_ip: '最近登錄 IP',
    last_login: '最後登錄時間',
    profit: '收益',
    rebate: '好友返傭',
    collect: '銷售金額',
    freeze: '凍結',
    payment: '購買',
    withdraw: '提現',
    topup: '充值',
    topup1: '充值金额',
    settlement_address: '結算地址',
    topup_address: '充值地址',
    available: '可用余額',
    pending_deposit_balance: '保證金',
    pending_payout_balance: '在途代付',
    freeze_balance: '在途返傭',
    manager_freeze_balance: '管理員凍結',
    ancest: '上級',
    descendant: '下級',
    select: '請選擇上下級',
    one: '一級下屬',
    two: '二級下屬',
    three: '三級下屬',
    level: '等級',
    buy: '購買',
    sale: '出售',
    account: '賬戶列表',
    rate: '返傭比例',
    sale_status: '代收狀態',
    sale_on: '開啟代收',
    manual_change_balance: '管理員操作',
    sale_collection: '銷售',
    ant_id: '螞蟻ID',
    start_sale: '開啟銷售',
    stop_sale: '停止銷售',
    account_ids: '產品賬戶',
    topup_transaction: '充U次數',
    buy_u_topup: '法幣買U',
    buy_u_topup_transaction: '法幣買U次數',
    topup_u_total: '充U總額',
    success_rate: '成功率',
    sale_transaction: '成功訂單',
    sale_order_count: '銷售接單',
    unlock: '解鎖',
    lock: '鎖定',
    freezeBalance: '凍結保證金',
    Balance: '保證金余額',
    backstage: '螞蟻後臺',
    friend_setting: '好友設置',
    close_self_rebate: '關閉接單傭金',
    close_friend_rebate: '關閉好友返傭',
    open_self_rebate: '開啟接单佣金',
    open_friend_rebate: '開啟好友返佣',
    recommender: '上級好友',
    deposit_balance: '凍結金額',
    negative_balance: '負余額',
    manager_freeze: '充值凍結',
    recently: '最近',
    last: '上次',
    previous: '前次',
    is_low_rating: '低评分',
    manage_freeze_balance: '充值冻结金额'
  },
  gcash: {
    search: '搜索内容',
    onlie_status: '在線狀態',
    account_status: '賬戶狀態',
    account_id: '賬戶編碼',
    phone_number: '手機號',
    sms_id: '短信轉發器ID',
    kyc_grade: 'KYC 等級',
    remain_money: '余額(PHP)',
    account_info: '賬戶信息',
    order_num: '收款筆數',
    money_num: '收款金額',
    addAccount: '創建賬戶',
    editAccount: '編輯賬戶',
    gcash_groups: '分組',
    accountInfo: ' 賬戶詳情',
    basic: '基本信息',
    collectionLog: '收款賬單',
    paymentLog: '代付賬單',
    smsLog: '短信賬單',
    actionLog: '操作日誌',
    ref_num: '訂單標識',
    pay_type: '類型',
    collection: '代收',
    payment: '代付',
    textMessage: '短信',
    from_name: '付款賬戶',
    to_name: '收款賬戶',
    money: '付款金額',
    messages: '回調來源',
    duanxin: '短信内容',
    open_date: '日期',
    open_time: '時間',
    status: '狀態',
    note: '備註',
    batchDel: '批量刪除',
    batchBulk: '批量轉賬',
    isDetele: '是否永久刪除以上賬戶',
    formPhone: '轉出賬戶',
    toPhone: '转入的手机号',
    phone: '轉入賬戶手機號',
    groupManagement: '分組管理',
    groupName: '分組名稱',
    openOnePay: '轉賬',
    balanceQuery: '批量余額查詢',
    batchLogin: '批量登錄',
    upExcel: 'Excel 批量上傳賬號',
    smsId: '短信轉發器 ID',
    wait: '待轉賬',
    fail: '失敗',
    success: '成功',
    twice: '二次驗證成功',
    ordinaryTransfer: '普通轉賬',
    bankTransfer: '銀行轉賬',
    bank_name: '銀行名稱',
    bank_code: '銀行編號',
    dst_accno: '銀行卡賬號',
    dst_accname: '銀行卡賬戶名',
    grouping: '批量分組',
    all_group: '以上賬戶是否全部轉入該分組',
    code: '（編碼）',
    content: '內容',
    uploader: '上傳 excel 文件',
    invite_login: '邀請登錄',
    bank_co: '銀行編碼',
    sign_up: '上號',
    invite_up: '邀請上號',
    batch_up: '批量上號',
    account: '在線賬戶',
    check: '賬單',
    gathering: '收款',
    anotherPay: '代付',
    withdrawal: '手動出款',
    last: '最後上號',
    daily_limit: '可用付款日限額',
    monthly_limit: '可用收款月限額',
    balance_limit: '余額上限',
    team: '團隊',
    login: '登錄 OTP 驗證'
  },
  payee: {
    payee: {
      info: '全球付款',
      paymentType: '收款人賬戶類型',
      type1: '個人',
      type2: '企業',
      area: '收款賬戶所在地區',
      currency: '收款货币',
      paymentMethod: '付款方式',
      upstreamAmount: '到賬金額',
      address: '收款人地址',
      feeType: '手續費類型',
      title1: '國際銀行轉賬方式，需提供：SWIFT號、銀行賬號',
      title4: '本地銀行轉賬方式，需提供：本地路徑清算號（或SWIFT號）、銀行賬號',
      title2:
        '時效:常規處理時效0-7個工作日(如遇到合規審查/技術維護/銀行故障不可抗力等因素，會有部分延遲)',
      title3:
        '時效:常規處理時效0-3個工作日(如遇到合規審查/技術維護/銀行故障不可抗力等因素，會有部分延遲)'
    }
  },
  appSoftware: {
    search: '軟件搜索',
    name: '軟件名稱',
    type: '軟件分類',
    order: '收單產品',
    download: '安裝',
    noapp: '當前標簽沒有應用軟件。',
    edit: '軟件詳情',
    sort: '排序權重',
    status: '插件狀態',
    tag: '插件類型',
    apply: '應用標簽',
    classify: '分類標簽',
    inactive: '未安裝',
    active: '已安裝',
    pendingBalance: '在途入金',
    ordernumber: '系统订单',
    upstream_ordernumber: '上游订单',
    amount: '支付金额',
    before_balance: '变动前余额',
    after_balance: '变动后余额',
    balanceStatus: '余额状态',
    add: '加钱',
    deduct: '扣钱',
    cause: '原因',
    deposit_balance: '在途入金',
    payout_balance: '在途出金',
    appInfo: '软件详情',
    fundInfo: '资金明细',
    payoutBalance: '在途代付',
    action: '結算代付類型',
    setting: '丟棄原因設置',
    create: '創建放棄原因',
    label: '標簽',
    value: '傳遞的 KEY',
    actionDetail: '螞蟻訂單的操作',
    file_url: '完成訂單轉賬截圖',
    ant_status: '期望狀態',
    order_status: '代付訂單狀態',
    reject: '駁回',
    ant_action: '螞蟻操作',
    picture: '查看圖片',
    finish: '支付完成',
    abandon: '丟棄訂單',
    ant_order_no: '銀行單號',
    payment: '平臺賬戶',
    approval: '審批操作',
    go: '通過',
    padding: '等待搶單',
    today_deposit_time: '入金查詢時間'
  },
  card: {
    user_name: '卡商名称',
    name: '卡商账户',
    cardManager: '卡商管理员',
    balance: '余额',
    transaction: '交易量',
    addCard: '创建卡商账户',
    config: '卡商账户设置',
    relevance: '关联账户',
    account: '产品账户',
    accountName: '账户',
    totalAmount: '交易量',
    successRate: '成功率',
    count: '笔数',
    balanceList: '余额记录',
    increaseBalance: '增加余额',
    relevanceAccount: '关联产品账户',
    balanceChange: '余额变动',
    cardName: '卡商',
    money: '金额',
    operate: '操作',
    add: '增加',
    reduce: '减少'
  },
  sms: {
    sms_account: '短信賬戶',
    merchant_balance: '商戶餘額',
    sms_logs: '短信記錄',
    account: '賬號',
    status: '狀態',
    enable: '啓用',
    noenable: '未啓用',
    balance: '餘額',
    gift_balance: '贈送餘額',
    merchant_no: '商戶號',
    name: '名稱',
    sms_balance: '短信餘額(USDT)',
    sms_balanc: '短信餘額',
    sms_id: '短信ID',
    send_mobile: '接收號碼',
    success: '成功',
    fail: '失敗',
    sms_message: '短信内容',
    send_time: '發送時間',
    addsmsAccount: '創建短信賬戶',
    editsmsAccount: '編輯短信賬戶',
    ref_no: '標識',
    amount: '金額',
    remark: '備註',
    ip_address: '源IP',
    account_number: '賬號',
    password: '密碼',
    price: '價格(USDT)',
    send_status: '發送狀態',
    send_state0: '發送成功',
    send_state1: '未發送',
    send_state2: '發送中',
    send_state3: '發送失敗',
    delivery_status: '送達狀態',
    delivery_status0: '不報告',
    delivery_status1: '已發送未送達',
    delivery_status2: '送達失敗',
    delivery_status3: '送達成功',
    delivery_status4: '送達超時',
    delivery_status5: '未知',
    smsSwitch: '短信開關',
    failed_sent: '發送失敗',
    success_rate: '成功率(%)',
    success_sent: '發送成功',
    total_cost: '總費用（USDT）',
    total_sent: '總發送'
  }
}
